import React, { useState } from "react";
import "./Header.scss";
import Logo from "../../Images/businessbay-rest.png";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import EnquirePopup from "./../../Components/EnquirePopup";

const Header = () => {

  const [showPopup, setShowPopup] = useState(false);

  const OpneLinkHandle = () =>{
    window.open("https://app.businessbay.io/register", "_blank");
  }

  const handlePopup = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };


  return (
    <Container>
        <div className="header_section">
        <div>
          <Link to="/">
              <img src={Logo} />
          </Link>
        </div>

        <div className="header_right_button">
          <button 
          // onClick={OpneLinkHandle}
          onClick={handlePopup}
          >Start free trial</button>
        </div>
        {showPopup && (
       <EnquirePopup   open={showPopup} onClose={closePopup} setOpen={setShowPopup}/>
      )}
      </div>
    </Container>
    // <div className="headersectiondiv">
      
    // </div>
  );
};

export default Header;
